import { Div, CollectionView, Span, Collection, Label } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";
import { TableColumnV2 } from "./TableColumnV2";


export class TableViewer<T> extends Div
{
    public static Name = "TableViewer";
    public static DefaultCssClasses = "uk-table uk-table-small uk-table-divider uk-table-middle";

    private readonly dataView!: CollectionView<T>;
    public columns: TableColumnV2<T>[] = [];
    private body = new Div("");
    private whenEmpty: appendable = new Span("No results").Style("display: block; margin: 48px 0; text-align: center; white-space: nowrap;");

    constructor(data?: T[] | Collection<T> | CollectionView<T>)
    {
        super("better-table");

        if (data && data instanceof Array)
        {
            this.dataView = new CollectionView<T>(new Collection<T>(data)).Refresh();
        }
        else if (data && data instanceof Collection)
        {
            this.dataView = new CollectionView<T>(data).Refresh();
        }
        else if (data && data instanceof CollectionView)
        {
            this.dataView = data;
        }

        this.dataView?.AddSubscriber(this);
    }

    public Reset(): this
    {
        this.columns = [];

        this.Clear();

        return this;
    }

    public WhenEmpty(component: appendable): this
    {
        this.whenEmpty = component;

        return this;
    }

    public Refresh(): void
    {
        this.body.Clear();

        if (this.dataView?.Items?.length === 0)
        {
            this.Append(this.whenEmpty);
        }
        else
        {
            this.Clear();
            
            this?.dataView?.Items?.forEach(record =>
            {
                const row = new Div("row");

                this.columns.forEach(c =>
                {
                    const cell = new Div("cell");
                    const elem = c.Mapping(record, cell, row, this);
                    let m: appendable[];
                    if (!Array.isArray(elem))
                        m = [elem];

                    else
                        m = elem;

                    m.forEach(e =>
                    {
                        cell.Append(new Div("cell-label").Append(...c.Header), e);
                    });

                    row.Append(cell);
                });

                this.Append(row);
            });
        }
    }

    public Build(): this
    {
        this.Append(new Div("row header").Append(
            ...this.columns.map(x => new Div("cell").Append(...x.Header)))
        );

        this.Refresh();
        this.Append(this.body);

        return this;
    }

    public AddColumn(
        header: appendable | appendable[],
        mapping: (
            record: T,
            cell: appendable,
            row: appendable,
            viewer: TableViewer<T>) => appendable | appendable[]): this
    {
        if (!Array.isArray(header)) // TODO: extension .ToArray ?
            header = [header];

        this.columns.push(new TableColumnV2(header, mapping));

        return this;
    }
}
